import { createAction, props } from '@ngrx/store';

// Models
import { JobFunction } from "src/app/contacts/model/jobFunction.model";
import { Salutation } from "src/app/contacts/model/salutation.model";
import { AddressClass } from "../../model/addressClass.model";
import { AddressType } from "../../model/addressType.model";
import { Country } from "../../model/country";
import { Language } from "../../model/language.model";
import { Source } from "../../model/source.model";

// Actions for Job Functions
export const getJobFunctions = createAction('[JOB_FUNCTIONS] - GET_JOB_FUNCTIONS');
export const beginGetJobFunctions = createAction('[JOB_FUNCTIONS] - BEGIN_GET_JOB_FUNCTIONS');
export const successGetJobFunctions = createAction('[JOB_FUNCTIONS] - SUCCESS_GET_JOB_FUNCTIONS', props<{ payload: JobFunction[] }>());
export const errorJobFunctions = createAction('[JOB_FUNCTIONS] - Error', props<any>());

// Actions for Salutations
export const getSalutations = createAction('[SALUTATIONS] - GET_SALUTATIONS');
export const beginGetSalutations = createAction('[SALUTATIONS] - BEGIN_GET_SALUTATIONS');
export const successGetSalutations = createAction('[SALUTATIONS] - SUCCESS_GET_SALUTATIONS', props<{ payload: Salutation[] }>());
export const errorSalutations = createAction('[SALUTATIONS] - Error', props<any>());

// Actions for Address Classes
export const getAddressClasses = createAction('[ADDRESS_CLASSES] - GET_ADDRESS_CLASSES');
export const beginGetAddressClasses = createAction('[ADDRESS_CLASSES] - BEGIN_GET_ADDRESS_CLASSES');
export const successGetAddressClasses = createAction('[ADDRESS_CLASSES] - SUCCESS_GET_ADDRESS_CLASSES', props<{ payload: AddressClass[] }>());
export const errorAddressClasses = createAction('[ADDRESS_CLASSES] - Error', props<any>());

// Actions for Address Types
export const getAddressTypes = createAction('[ADDRESS_TYPES] - GET_ADDRESS_TYPES');
export const beginGetAddressTypes = createAction('[ADDRESS_TYPES] - BEGIN_GET_ADDRESS_TYPES');
export const successGetAddressTypes = createAction('[ADDRESS_TYPES] - SUCCESS_GET_ADDRESS_TYPES', props<{ payload: AddressType[] }>());
export const errorAddressTypes = createAction('[ADDRESS_TYPES] - Error', props<any>());

// Actions for Countries
export const getCountries = createAction('[COUNTRIES] - GET_COUNTRIES');
export const beginGetCountries = createAction('[COUNTRIES] - BEGIN_GET_COUNTRIES');
export const successGetCountries = createAction('[COUNTRIES] - SUCCESS_GET_COUNTRIES', props<{ payload: Country[] }>());
export const errorCountries = createAction('[COUNTRIES] - Error', props<any>());

// Actions for Languages
export const getLanguages = createAction('[LANGUAGES] - GET_LANGUAGES');
export const beginGetLanguages = createAction('[LANGUAGES] - BEGIN_GET_LANGUAGES');
export const successGetLanguages = createAction('[LANGUAGES] - SUCCESS_GET_LANGUAGES', props<{ payload: Language[] }>());
export const errorLanguages = createAction('[LANGUAGES] - Error', props<any>());

// Actions for Sources
export const getSources = createAction('[SOURCES] - GET_SOURCES');
export const beginGetSources = createAction('[SOURCES] - BEGIN_GET_SOURCES');
export const successGetSources = createAction('[SOURCES] - SUCCESS_GET_SOURCES', props<{ payload: Source[] }>());
export const errorSources = createAction('[SOURCES] - Error', props<any>());